import AIMaturityEvalution from "../home/assessment/ai-maturity-evaluation";
import GapAnalysis from "../home/assessment/gap-analysis";
import AIRoadmap from "../home/execution-plan/ai-roadmap";
import AIUsecase from "../home/execution-plan/ai-usecase";
import Timeline from "../home/execution-plan/timeline";
import CompanyIntro from "../home/intro/company-intro";
import Objectives from "../home/intro/objective";
import PageNotFound from "../home/PageNotFound";
import ClinetAssistanceChannel from "../home/support/clinet-assistance-channel";
import ContactUs from "../home/support/clinet-assistance-channel";
import FAQ from "../home/support/faq";
import AIValue from "../home/value-and-impact/ai-value";
import StrategicImpact from "../home/value-and-impact/strategic-impact";
import TrackRecord from "../home/why-incorp/track-record";
import UniqueDifferentiator from "../home/why-incorp/unique-differentiator";
import DashboardPage from "../page/dashboard";

const appRoutes = [
  {
    path: ``,
    element: <DashboardPage />,
    children: [
      {
        path: ``,
        element: <Objectives />,
      },
      {
        path: `company-intro`,
        element: <CompanyIntro />,
      },
      {
        path: `ai-maturity-eval`,
        element: <AIMaturityEvalution />,
      },
      {
        path: `gap-analysis`,
        element: <GapAnalysis />,
      },
      {
        path: `ai-value`,
        element: <AIValue />,
      },
      {
        path: `strategic-impact`,
        element: <StrategicImpact />,
      },
      {
        path: `ai-roadmap`,
        element: <AIRoadmap />,
      },
      {
        path: `ai-usecase`,
        element: <AIUsecase />,
      },
      {
        path: `timeline`,
        element: <Timeline />,
      },
      {
        path: `unique-diffs`,
        element: <UniqueDifferentiator />,
      },
      {
        path: `track-record`,
        element: <TrackRecord />,
      },
      {
        path: `faq`,
        element: <FAQ />,
      },
      {
        path: `client-assistance-channel`,
        element: <ClinetAssistanceChannel />,
      },
    ]
  },
  {
    path: `*`,
    element: <PageNotFound />,
  },
];

export { appRoutes };
